
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComCallActiveGoogle as ObiComCallActiveGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-call-active-google.js';
 
 
 

 
 export const ObiComCallActiveGoogle = createComponent({
   react: React,
   tagName: 'obi-com-call-active-google',
   elementClass: ObiComCallActiveGoogleElement,
   events: {
     
   }
  });
 
 